import React, { useState, useContext, useEffect, useRef } from "react";
import PaineGleba from "./PainelGleba";
import "./index.css";
import { IoMdAddCircleOutline } from "react-icons/io";
import { FiSave } from "react-icons/fi";

import { Button } from "rsuite";
import { useQuery } from "@tanstack/react-query";
import {
  getConfiguracaRelatorio,
  createGleba,
} from "../../../Services/programation.service";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ConfiguracaoGlebaContext } from "../../../contexts/ConfiguracaoGlebaContext";

import { Circles } from "react-loader-spinner";
import CopiarCultivarModal from "./CopiarCultivarModal";
const AddGleba = () => {
  const {
    configuracaoGleba,
    setConfiguracaoGleba,
    activeCulturaIndex,
    setActiveCulturaIndex,
    programacaoAlterada,
    setProgramacaoAlterada,
  } = useContext(ConfiguracaoGlebaContext);
  const isAddButtonVisible = !!configuracaoGleba?.culturas?.length;
  const glebaArea = Number(
    configuracaoGleba?.defaultValues?.area ?? configuracaoGleba?.gleba?.area ?? 0
  );
  const areaUsada = (configuracaoGleba?.culturas || []).reduce(
    (soma, c) => soma + (Number(c?.area) || 0),
    0
  );
  const areaRestante = Number((glebaArea - areaUsada).toFixed(3));
  const areaConfere = Math.abs(areaRestante) < 0.001;
  const areaExcedeu = areaRestante < -0.001;
  // Números com vírgula (padrão pt-BR) e sem dízima de ponto flutuante
  const fmtHa = (n) =>
    Number((Number(n) || 0).toFixed(3)).toLocaleString("pt-BR", {
      maximumFractionDigits: 3,
    });
  const isButtonsVisible =
    configuracaoGleba.tipoSafraId &&
    configuracaoGleba.safraId &&
    configuracaoGleba.glebaId;
  const [isLoading, setIsLoading] = useState(false);
  const [showCopiarModal, setShowCopiarModal] = useState(false);

  const handleAddCultura = () => {
    const existentes = configuracaoGleba?.culturas || [];
    const usado = existentes.reduce((s, c) => s + (Number(c?.area) || 0), 0);
    const restante = Number((glebaArea - usado).toFixed(3));
    const novoBloco = {
      // A 1a cultura ja nasce com a area cheia do talhao; as proximas com o que sobrou.
      area: restante > 0 ? restante : null,
      espaco: null,
      similar: false,
      quantidade: null,
      cultivarId: "",
      propositoId: "",
      ordemPlantio: null,
    };
    setConfiguracaoGleba((prevState) => ({
      ...prevState,
      culturas: [...(prevState?.culturas || []), novoBloco],
    }));
    setActiveCulturaIndex(existentes.length);
    setProgramacaoAlterada(true);
  };

  // Duplica a cultivar da aba ATIVA (com todos os insumos) numa nova aba, pra
  // reaproveitar o manejo e só trocar a cultivar. Copia do estado atual (na tela),
  // incluindo o que ainda não foi salvo.
  const handleDuplicarCultura = () => {
    const existentes = configuracaoGleba?.culturas || [];
    const bloco = existentes[activeCulturaIndex];
    if (!bloco) return;
    const clone = JSON.parse(JSON.stringify(bloco)); // cópia profunda
    // ids novos nos insumos (pra excluir/reordenar/keys funcionarem sem conflito)
    const carimbo = Date.now();
    [
      "adubacao",
      "adubacaoFolhar",
      "herbicida",
      "inseticida",
      "fungicida",
      "outrosProdutos",
      "tratamentoSementes",
    ].forEach((k) => {
      clone[k] = (clone[k] || []).map((item, i) => ({
        ...item,
        id: `dup-${carimbo}-${k}${i}`,
      }));
    });
    const novoIndex = existentes.length;
    setConfiguracaoGleba((prevState) => ({
      ...prevState,
      culturas: [...(prevState?.culturas || []), clone],
    }));
    setActiveCulturaIndex(novoIndex);
    setProgramacaoAlterada(true);
    toast.info("Cultivar duplicada — agora troque a cultivar e salve.");
  };

  const handleRemoveCultura = (index) => {
    const bloco = configuracaoGleba?.culturas?.[index];
    const nomeBloco = bloco?.cultura?.nome
      ? `${bloco.cultura.nome}${bloco?.cultivar?.nome ? " · " + bloco.cultivar.nome : ""}`
      : `Cultura ${index + 1}`;
    if (
      !window.confirm(
        `Remover "${nomeBloco}" e todo o manejo dela (adubação, defensivos etc.)?`
      )
    )
      return;
    const novas = [...(configuracaoGleba?.culturas || [])];
    novas.splice(index, 1);
    setConfiguracaoGleba((prevState) => ({
      ...prevState,
      culturas: novas,
    }));
    // Se removeu uma aba ANTES da ativa, a ativa anda uma posição pra trás
    // (senão a seleção "pula" pra cultivar errada).
    setActiveCulturaIndex((atual) =>
      index < atual
        ? Math.max(0, atual - 1)
        : Math.max(0, Math.min(atual, novas.length - 1))
    );
    setProgramacaoAlterada(true);
  };

  const programationRelatorioFetch = async () => {
    if (isButtonsVisible) {
      setIsLoading(true);
      const { res } = await getConfiguracaRelatorio(configuracaoGleba);

      if (res?.data) {
        setIsLoading(false);
        return res.data;
      } else {
        setIsLoading(false);
        return {};
      }
    }
  };

  const programationRelatorioQuery = useQuery(
    [
      "configuracaoRelatorioAddGleba",
      configuracaoGleba.tipoSafraId,
      configuracaoGleba.safraId,
      configuracaoGleba.glebaId,
    ],
    programationRelatorioFetch,
    {
      // enabled: !configuracaoGleba.id,
      initialData: undefined,
    }
  );
  const formValueMap = (data) => {
    return {
      culturas: data.culturas.map((cultura) => ({
        ...cultura,
        culturaId: cultura?.cultura?.id,
        cultivarId: cultura?.cultivar?.id,
        propositoId: cultura?.proposito?.id,
        tratamentoSementes: (cultura?.tratamentoSementes || []).map(
          (tratamentoSemente) => ({
            ...tratamentoSemente,
            produtoTratamentoId: tratamentoSemente?.produtoTratamento?.id,
            classeTratamentoId: tratamentoSemente?.classeTratamento?.id,
          })
        ),
        adubacao: (cultura?.adubacao || []).map((adubacao) => ({
          ...adubacao,
          produtoAdubacaoId: adubacao?.produtoAdubacao?.id,
          epocaAdubacaoId: adubacao?.epocaAdubacao?.id,
          tipoAdubacaoId: adubacao?.tipoAdubacao?.id,
        })),
        adubacaoFolhar: (cultura?.adubacaoFoliar || []).map(
          (adubacaoFoliar) => ({
            ...adubacaoFoliar,
            produtoAdubacaoFolharId: adubacaoFoliar?.produtoAdubacaoFolhar?.id,
          })
        ),
        herbicida: (cultura?.herbicida || []).map((herbicida) => ({
          ...herbicida,
          produtoHerbicidaId: herbicida?.produtoHerbicida?.id,
          tipoHerbicidaId: herbicida?.tipoHerbicida?.id,
        })),
        inseticida: (cultura?.inseticida || []).map((inseticida) => ({
          ...inseticida,
          produtoInseticidaId: inseticida?.produtoInseticida?.id,
        })),
        fungicida: (cultura?.fungicida || []).map((fungicida) => ({
          ...fungicida,
          produtoFungicidaId: fungicida?.produtoFungicida?.id,
        })),
        outrosProdutos: (cultura?.outrosProdutos || []).map(
          (outrosProdutos) => ({
            ...outrosProdutos,
            produtoOutrosProdutosId: outrosProdutos?.produtoOutrosProdutos?.id,
          })
        ),
      })),
    };
  };

  // Guarda qual talhão já foi carregado do servidor. Assim uma REBUSCA do mesmo
  // talhão (ex.: ao trocar de aba o painel remonta) NÃO sobrescreve o que está
  // na tela — senão apaga uma cultivar clonada/editada que ainda não foi salva
  // (era o bug do "clone aparece e some").
  const talhaoCarregadoRef = useRef(null);

  useEffect(() => {
    const data = programationRelatorioQuery?.data;
    if (data === undefined) return; // ainda buscando
    const chave = `${configuracaoGleba.glebaId}|${configuracaoGleba.safraId}|${configuracaoGleba.tipoSafraId}`;
    const mudouTalhao = talhaoCarregadoRef.current !== chave;
    // Só PRESERVA o estado da tela (não sobrescreve com o servidor) quando é o
    // MESMO talhão E há edição não-salva na tela (um clone que não pode sumir).
    // Se não há nada pendente, deixa o servidor mandar — assim mudanças feitas
    // por fora (ex.: Manutenção em massa) aparecem sem precisar dar F5.
    if (!mudouTalhao && programacaoAlterada) return;
    talhaoCarregadoRef.current = chave;

    if (data?.id) {
      const dataMap = formValueMap(data);
      setConfiguracaoGleba((prevState) => ({
        ...prevState,
        ...data,
        ...dataMap,
      }));
    } else {
      setConfiguracaoGleba((prevState) => ({
        ...prevState,
        culturas: [],
      }));
    }
    if (mudouTalhao) {
      // Talhão NOVO: começa na 1ª aba e zera o "alterado".
      setActiveCulturaIndex(0);
      setProgramacaoAlterada(false);
    } else if (data?.id) {
      // Mesmo talhão (rebusca): NÃO volta pra aba 0 — só garante que a aba
      // ativa ainda existe (senão, ao trocar de aba, a tela voltava pra 1ª).
      const n = (data.culturas || []).length;
      setActiveCulturaIndex((atual) => Math.min(atual, Math.max(0, n - 1)));
    }
  }, [programationRelatorioQuery?.data]);

  const handleSubmit = async (body) => {
    const culturas = configuracaoGleba.culturas || [];
    // Com mais de uma aba, cada uma precisa da cultivar escolhida (senão duas
    // abas da mesma cultura sem cultivar ficariam idênticas e duplicariam insumos).
    // Mensagem clara em vez de "aba duplicada" quando o usuário só não escolheu ainda.
    if (
      culturas.length > 1 &&
      culturas.some((c) => c?.culturaId && !c?.cultivarId)
    ) {
      toast.warning("Escolha a cultivar de cada aba antes de salvar.");
      return;
    }
    // Duas abas com a MESMA cultura e cultivar duplicariam os insumos no banco.
    const chaves = culturas.map(
      (c) => `${c?.culturaId || ""}|${c?.cultivarId || ""}`
    );
    if (new Set(chaves).size !== chaves.length) {
      toast.warning(
        "Há duas abas com a mesma cultura e cultivar. Junte os insumos numa aba só ou troque a cultivar de uma delas."
      );
      return;
    }
    // Só bloqueia por excesso se o talhão TEM área cadastrada (área 0 = sem cadastro).
    if (glebaArea > 0 && areaExcedeu) {
      toast.warning(
        `A soma das áreas (${fmtHa(areaUsada)} ha) passou da área do talhão (${fmtHa(glebaArea)} ha). Ajuste antes de salvar.`
      );
      return;
    }
    // Garantia: cada insumo leva a area da SUA cultivar (insumo cobre a area inteira da cultivar).
    const ajustarArea = (lista, area) =>
      (lista || []).map((item) => ({ ...item, area }));
    const culturasNormalizadas = (configuracaoGleba.culturas || []).map((c) => ({
      ...c,
      adubacao: ajustarArea(c.adubacao, c.area),
      adubacaoFolhar: ajustarArea(c.adubacaoFolhar, c.area),
      herbicida: ajustarArea(c.herbicida, c.area),
      inseticida: ajustarArea(c.inseticida, c.area),
      fungicida: ajustarArea(c.fungicida, c.area),
      outrosProdutos: ajustarArea(c.outrosProdutos, c.area),
      tratamentoSementes: ajustarArea(c.tratamentoSementes, c.area),
    }));
    const payload = { ...configuracaoGleba, culturas: culturasNormalizadas };
    setIsLoading(true); // mostra o carregando DURANTE o salvamento (e evita clique duplo)
    const { res } = await createGleba(payload);
    setIsLoading(false);
    if (res) {
      setProgramacaoAlterada(false);
      toast.success("Configuração salva com sucesso!");
    } else {
      toast.error("Falha ao salvar a configuração!");
    }
  };

  return (
    <div className="panel-gleba">
      {!!configuracaoGleba?.culturas?.length && (
        <>
          <div className="cultivar-tabs">
            {configuracaoGleba.culturas.map((c, i) => {
              const nome = c?.cultura?.nome
                ? c.cultura.nome +
                  (c?.cultivar?.nome ? " · " + c.cultivar.nome : "")
                : `Cultura ${i + 1}`;
              const ativa = i === activeCulturaIndex;
              return (
                <div
                  key={i}
                  className={ativa ? "cultivar-tab ativa" : "cultivar-tab"}
                  onClick={() => setActiveCulturaIndex(i)}
                  role="tab"
                  aria-selected={ativa}
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ")
                      setActiveCulturaIndex(i);
                  }}
                >
                  <span title={nome}>
                    {nome}
                    {c?.area ? ` (${fmtHa(c.area)} ha)` : ""}
                  </span>
                  {configuracaoGleba.culturas.length > 1 && (
                    <span
                      className="cultivar-tab-remove"
                      title="Remover esta cultivar"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleRemoveCultura(i);
                      }}
                    >
                      ×
                    </span>
                  )}
                </div>
              );
            })}
            <div
              className="cultivar-tab-add"
              onClick={handleAddCultura}
              title="Adicionar outra cultivar neste talhão"
            >
              + Cultivar
            </div>
            <div
              className="cultivar-tab-add"
              onClick={handleDuplicarCultura}
              title="Copiar esta cultivar (com o manejo) numa nova aba — depois é só trocar a cultivar"
            >
              ⧉ Duplicar cultivar
            </div>
            <div
              className="cultivar-tab-add"
              onClick={() => setShowCopiarModal(true)}
              title="Copiar uma cultivar (com o manejo) de outro talhão"
            >
              ⧉ Copiar de outro talhão
            </div>
          </div>

          <div
            className={
              areaExcedeu
                ? "resumo-area nao-confere"
                : areaConfere
                ? "resumo-area confere"
                : "resumo-area incompleto"
            }
          >
            Talhão: <b>{fmtHa(glebaArea)} ha</b> &nbsp;·&nbsp; Usado:{" "}
            <b>{fmtHa(areaUsada)} ha</b> &nbsp;·&nbsp;{" "}
            {areaConfere ? (
              <span>soma confere ✓</span>
            ) : areaExcedeu ? (
              <span>
                Passou {fmtHa(Math.abs(areaRestante))} ha do talhão — ajuste
              </span>
            ) : (
              <span>
                Falta {fmtHa(areaRestante)} ha (pode salvar e completar depois)
              </span>
            )}
          </div>

          <PaineGleba
            key={activeCulturaIndex}
            data={{ programationRelatorio: configuracaoGleba }}
          />
        </>
      )}
      {isButtonsVisible && isLoading !== true ? (
        <div className="select-component-insumos">
          {!isAddButtonVisible && (
            <div
              style={{
                justifyContent: "left",
                display: "flex",
                width: "100%",
                flexDirection: "column",
              }}
            >
              A gleba ainda não possui uma configuração. Clique em adicionar
              para continuar com a configuração.
              <Button
                className="button-add-gleba"
                variant="danger"
                size="lg"
                onClick={handleAddCultura}
              >
                Adicionar Cultura
                <IoMdAddCircleOutline />
              </Button>
              <Button
                className="button-add-gleba"
                variant="danger"
                size="lg"
                style={{ marginTop: "8px" }}
                onClick={() => setShowCopiarModal(true)}
              >
                Copiar de outro talhão
              </Button>
            </div>

            //ADICIONAR TEXTO
          )}
          {isAddButtonVisible && (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                style={{
                  width: "170px",
                  padding: "23px 16px",
                  margin: " 30px 0 0 0 ",
                }}
                className="button-add-gleba"
                variant="danger"
                size="lg"
                onClick={handleSubmit}
              >
                Salvar Gleba
                <FiSave />
              </Button>
            </div>
          )}
        </div>
      ) : (
        ""
      )}
      {isLoading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            // marginTop: "100px",
            position: "fixed",
            width: "100vw",
            height: "100vh",
            background: "rgb(163 161 161 / 26%)",
            top: "0",
            left: "0",
            alignItems: "center",
            zIndex: 2000,
          }}
        >
          {" "}
          <Circles
            height="80"
            width="80"
            color="rgba(1, 104, 32, 0.81)"
            ariaLabel="circles-loading"
            wrapperStyle={{}}
            wrapperClass=""
            visible={isLoading}
          />
        </div>
      )}
      <CopiarCultivarModal
        open={showCopiarModal}
        onClose={() => setShowCopiarModal(false)}
      />

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      {/* Same as
      {/* <ToastContainer /> */}
    </div>
  );
};

export default AddGleba;
